export default {
  components: {
    homeSkeleton: 'dt.domains.home.components.homeSkeleton',
    condensedCarousels: {
      module: 'dt.domains.home.components.condensedCarousels.module',
      pill: 'dt.domains.home.components.condensedCarousels.pill',
      rail: 'dt.domains.home.components.condensedCarousels.rail',
      skeleton: 'dt.domains.home.components.condensedCarousels.skeleton',
      viewAll: 'dt.domains.home.components.condensedCarousels.viewAll',
    },
  },
};
